import * as React from 'react';
import { UncontrolledAssignButton, Props } from './UncontrolledAssignButton';

/**
 * Renders the AssignButton with an additional message explaining what it's for
 */
export const AssignTag: React.FC<Props> = (props) => {
  return (
    <div className="space-y-2">
      <p className="font-medium">
        Tag your containers with a Reference ID for better reports (optional):
      </p>
      <UncontrolledAssignButton {...props} />
    </div>
  );
};
AssignTag.displayName = 'CustomerTag.AssignTag';
